import { render, staticRenderFns } from "./RecentAsset.vue?vue&type=template&id=d0ba63f8&scoped=true&"
import script from "./RecentAsset.vue?vue&type=script&lang=js&"
export * from "./RecentAsset.vue?vue&type=script&lang=js&"
import style0 from "./RecentAsset.vue?vue&type=style&index=0&id=d0ba63f8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0ba63f8",
  null
  
)

export default component.exports